@use '@lib/assets/styles/main.scss' as *;

.main {
  display: block;
  font-size: 12px;
  font-weight: 300;
  line-height: 18px;
  margin-top: 8px;
  text-align: right;
}
